import { useRouter } from "next/router";

const usePreview = () => {
  const { asPath } = useRouter();

  return { isPreview: asPath?.endsWith("/register/preview") || false };
};

export default usePreview;
